import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";

import Lottie from 'lottie-react';

import { useRecoilState } from 'recoil';
import { roleAtom } from '../core/config/atoms';

import animPage from 'assets/anim/anim-pageload.json';

import ServiceORG from 'services/serviceOrg';
import ServiceSubs from 'services/serviceSubs';
import ServiceOutlet from 'services/serviceOutlet';

import PaneOutlet from 'panels/orgs/panes/PaneOutlet';

import ComponentSubsChart from 'core/widgets/components/charts/ComponentSubsChart';
import moment from 'moment';

export default function LayoutPartnerHome() {
    const [charts, setCharts] = useState([]);

    const [doc, setDoc] = useState({});
    const [sub, setSub] = useState({});
    const [subData, setSubData] = useState({});

    const [rolsData] = useRecoilState(roleAtom);

    const [loading, setLoading] = useState(true);

    const orgService = new ServiceORG();

    const genrateChartData = () => {
        (async function () {
            var res = await orgService.getSubLicById({ 'ordid': doc.id }, doc.ordid);
            setSubData(res.data);
            let chartData = [
                { status: "Active", subscription: res.data.active, fill: "var(--color-chrome)" },
                { status: "Expired", subscription: res.data.expired, fill: "var(--color-safari)" },
                { status: "Not in use", subscription: (res.data.total - res.data.active), fill: "var(--color-firefox)" },
            ];
            setCharts(chartData);
            setLoading(false);
        })();
    }

    const loadData = () => {
        setLoading(true);
        (async function () {
            let body = { 'ordid': rolsData.orgs[0] };
            var res = await orgService.getOrgById(body, '');
            setDoc(res.data);
        })();
    }

    useEffect(() => {
        if (Object.keys(rolsData).length !== 0) {
            loadData();
        }
    }, [rolsData]);

    useEffect(() => {
        if (Object.keys(doc).length !== 0) {
            genrateChartData();
        }
    }, [doc]);

    return (
        <div className='w-full h-screen overflow-hidden'>
            <ScrollArea className='w-full h-screen bg-white'>
                {
                    loading && <div className='flex items-center justify-center w-full h-screen'>
                        <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                    </div>
                }
                {
                    !loading && <div>
                        <div className='h-[320px] bg-red-50 px-4 relative'>
                            <div className='h-[220px] bg-prime rounded-b-md'></div>
                            <div className='w-[180px] h-[180px] bg-white border-[6px] border-red-50 rounded-full absolute top-[120px] ml-8'>
                                <img src={doc.profile_media.fileurl} alt='Profile Pic' className='w-full h-full rounded-full' />
                            </div>
                            <h1 className='ml-[220px] text-4xl font-medium absolute'>{doc.name}</h1>
                        </div>
                        <div className='bg-gray-50'>
                            <div className='w-full rounded-md p-4 mt-4'>
                                <div className='w-1/2 py-6 border rounded bg-white grid grid-cols-6'>
                                    <div className='col-span-3'>
                                        <ComponentSubsChart data={charts} total={subData.total} active={subData.active} />
                                    </div>
                                    <div className='col-span-3'>
                                        <h2 className='text-xl font-medium'>Subscription Summery</h2>
                                        <h3 className='text-base font-medium'>Ending at {moment(sub.endDate).format("DD, MMM yy")}</h3>
                                        <ul className='mt-6 text-sm space-y-1'>
                                            <li className='flex items-center'>
                                                <div className='w-2 h-2 bg-prime mr-2 rounded-full'></div>
                                                <div>{charts.length === 0 ? 0 : charts[0].subscription} Active</div>
                                            </li>
                                            <li className='flex items-center'>
                                                <div className='w-2 h-2 bg-prime mr-2 rounded-full'></div>
                                                <div>{charts.length === 0 ? 0 : charts[1].subscription} Expired</div>
                                            </li>
                                            <li className='flex items-center'>
                                                <div className='w-2 h-2 bg-prime mr-2 rounded-full'></div>
                                                <div>{charts.length === 0 ? 0 : charts[2].subscription} Not in user</div>
                                            </li>
                                            <li className='font-medium flex items-center'>
                                                <div className='w-2 h-2 bg-prime mr-2 rounded-full'></div>
                                                <div>{subData.total} Total Subscription</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <h2 className='text-xl font-medium my-4'>Outlets</h2>
                                <PaneOutlet org={doc} data={subData} refresh={loadData} />
                            </div>
                        </div>
                    </div>
                }
            </ScrollArea>
        </div>
    )
}
